/*******************************************
 * Expresiones regulares y tipos
 *******************************************/
const NifPersonRegex = /^[0-9]{8}[A-Z]$/;
const NifCorporationRegex = /^[ABCDEFGHJNPQRSUVW][0-9]{7}[0-9A-Z]$/;
const NieRegex = /^[XYZ][0-9]{7}[A-Z]$/;
/*******************************************
 * Función para determinar el tipo
 *******************************************/
function getDocType(documentId) {
    if (NifPersonRegex.test(documentId))
        return 'NifPerson';
    if (NifCorporationRegex.test(documentId))
        return 'NifCorporation';
    if (NieRegex.test(documentId))
        return 'Nie';
    return 'Unknown';
}
/*******************************************
 * Cálculo de letra de control (para NIF persona/NIE)
 *******************************************/
function calculateControlLetter(num) {
    const letters = [
        'T', 'R', 'W', 'A', 'G', 'M', 'Y', 'F', 'P', 'D', 'X', 'B', 'N', 'J', 'Z', 'S', 'Q', 'V', 'H', 'L', 'C', 'K', 'E'
    ];
    return letters[num % 23];
}
/*******************************************
 * Validar NIF de persona
 * (p.ej. 12345678Z)
 *******************************************/
function isValidNifPerson(documentId) {
    const number = parseInt(documentId.slice(0, 8), 10); // 8 dígitos
    const letter = documentId[8]; // última letra
    return letter === calculateControlLetter(number);
}
/*******************************************
 * Validar NIE
 * (p.ej. X1234567T)
 *******************************************/
function isValidNie(documentId) {
    const letter = documentId[8]; // última letra
    let numericValue = documentId.toUpperCase();
    // Sustituimos X, Y, Z por 0, 1, 2
    switch (numericValue[0]) {
        case 'X':
            numericValue = '0' + numericValue.slice(1);
            break;
        case 'Y':
            numericValue = '1' + numericValue.slice(1);
            break;
        default:
            // Z
            numericValue = '2' + numericValue.slice(1);
            break;
    }
    const number = parseInt(numericValue.slice(0, 8), 10);
    return letter === calculateControlLetter(number);
}
/*******************************************
 * Validar NIF corporativo
 * (replica la lógica c# con regionCodes, sumas, etc.)
 *******************************************/
function isValidNifCorporation(documentId) {
    // Ej: documentId = "B1234567H" => 9 caracteres
    // C#: var letter = documentId.Substring(0,1);
    const letter = documentId[0];
    // C#: var number = documentId.Substring(8,1);
    const controlChar = documentId[8];
    // C#: var regionCode = documentId.Substring(1,2);
    const regionCode = documentId.substring(1, 3);
    const letters = ["A", "B", "C", "D", "E", "F", "G", "H", "J", "N", "P", "Q", "R", "S", "U", "V", "W"];
    const regionCodes = [
        "01", "02", "03", "53", "54", "04", "05", "06", "07", "57", "08", "58", "59", "60", "61", "62", "63", "64",
        "09", "10", "11", "72", "12", "13", "14", "56", "15", "70", "16", "17", "55", "18", "19", "20", "71", "21",
        "22", "23", "24", "25", "26", "27", "28", "78", "79", "80", "81", "82", "83", "84", "29", "92", "93", "30",
        "73", "31", "32", "33", "74", "34", "35", "76", "36", "94", "37", "38", "75", "39", "40", "41", "91", "42",
        "43", "77", "44", "45", "46", "96", "97", "98", "47", "48", "95", "49", "50", "99", "51", "52", "87", "66",
        "85", "68", "86", "90", "65", "67", "00", "88"
    ];
    // Verifica regionCode
    if (!regionCodes.includes(regionCode)) {
        return false;
    }
    let evenNumberSum = 0;
    let oddNumberSum = 0;
    // Replicamos la lógica c# del for (counter = 1; counter < 7; counter++)
    // con increments de 2. Ojo, c# hace counter++ dentro del loop
    // Reproducimos la misma secuencia de indices.
    let counter = 1;
    while (counter < 7) {
        const doubled = 2 * parseInt(documentId.substring(counter, counter + 1), 10); // p.e. (2 * int.Parse(documentId.Substring(counter,1)))
        const doubledString = `${doubled}0`; // c# => (2 * int.Parse(...)) + "0"
        // Sumamos dígitos
        oddNumberSum += parseInt(doubledString[0], 10) + parseInt(doubledString[1], 10);
        counter++;
        evenNumberSum += parseInt(documentId.substring(counter, counter + 1), 10);
        counter++;
    }
    // Ahora repetimos la última parte c#:
    // c# => currentPosition = (2 * int.Parse(documentId.Substring(counter, 1))) + "0";
    // oddNumberSum += ...
    const lastDoubled = 2 * parseInt(documentId.substring(counter, counter + 1), 10);
    const lastString = `${lastDoubled}0`;
    oddNumberSum += parseInt(lastString[0], 10) + parseInt(lastString[1], 10);
    const total = evenNumberSum + oddNumberSum;
    let controlDigit = parseInt(total.toString().slice(-1), 10); // c# => total.ToString().Substring(total.Length - 1, 1)
    controlDigit = 10 - controlDigit;
    if (controlDigit === 10)
        controlDigit = 0;
    // c# => if (int.TryParse(number, out var digit)) => number = controlChar
    const parsedDigit = parseInt(controlChar, 10);
    if (!isNaN(parsedDigit)) {
        // c# => return controlDigit == digit;
        return controlDigit === parsedDigit;
    }
    // c# => letter switch
    // letter = letter inicial, controlChar = la ultima
    if (["P", "Q", "R", "S", "W", "N"].includes(letter)) {
        // c# => controlDigit > 0 && number == letters[controlDigit - 1]
        if (controlDigit > 0) {
            // letters array
            if (controlDigit - 1 < 0 || controlDigit - 1 >= letters.length)
                return false;
            return controlChar === letters[controlDigit - 1];
        }
        return false;
    }
    else if (["A", "B", "E", "H"].includes(letter)) {
        // c# => number == controlDigit.ToString()
        return controlChar === controlDigit.toString();
    }
    else {
        // c# => controlDigit > 0 && (number == letters[controlDigit - 1] || number == controlDigit.ToString())
        if (controlDigit > 0) {
            const letterCandidate = letters[controlDigit - 1];
            return controlChar === letterCandidate || controlChar === controlDigit.toString();
        }
        return false;
    }
}
/*******************************************
 * isValidNaturalPersonNumber
 * (usa isValidNifPerson o isValidNie)
 *******************************************/
function isValidNaturalPersonNumber(documentId) {
    if (!documentId || documentId.length !== 9)
        return false;
    documentId = documentId.toUpperCase();
    const docType = getDocType(documentId);
    switch (docType) {
        case 'NifPerson':
            return isValidNifPerson(documentId);
        case 'Nie':
            return isValidNie(documentId);
        default:
            return false;
    }
}
/*******************************************
 * isValidLegalPersonNumber
 * (usa isValidNifCorporation)
 *******************************************/
function isValidLegalPersonNumber(documentId) {
    if (!documentId || documentId.length !== 9)
        return false;
    documentId = documentId.toUpperCase();
    const docType = getDocType(documentId);
    if (docType === 'NifCorporation') {
        return isValidNifCorporation(documentId);
    }
    return false;
}
/*******************************************
 * Exportar las funciones
 *******************************************/
// Por ejemplo, en un archivo "nifValidation.ts" las exportas:
export { isValidNaturalPersonNumber, isValidLegalPersonNumber,
// Si quieres exportar isValidNifPerson, isValidNie, etc.
 };
